/* SiteSelectorSelect.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { BodyNormal, BodySmall, H4, Stripe } from '@atlassian/mpac-primitives';
import { useEffect, useState } from 'react';
import { SiteCompatibleProducts } from '../../SiteSelectorDialog/SiteCompatibleProducts';
import SiteSelectorError from '../../SiteSelectorDialog/SiteSelectorError';
import SiteSelectorPermissionErrorSection from '../../SiteSelectorDialog/SiteSelectorPermissionErrorSection';
import { formatLabel } from '../../SiteSelectorDialog/SiteSelectorSelect/SiteSelectorSelect';
import SiteSelectorSelectSection from '../../SiteSelectorDialog/SiteSelectorSelectSection';
import { PaidAppPricing } from './PaidAppPricing';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _11 = "@media (min-width:64rem){._10m4kb7n{flex-grow:1}._1vdkkb7n{flex-shrink:1}._1wzn1wug{flex-basis:auto}._1yagcwrd{padding:var(--_1ocxs6l)}._1mbp1wug{overflow-y:auto}}";
const _10 = "._1yt41ejb{padding:var(--ds-space-300,24px)}";
const _9 = "._k48pni7l{font-weight:600}";
const _8 = "._vwz4viql{line-height:2rem}";
const _7 = "._n3td1ejb{padding-bottom:var(--ds-space-300,24px)}";
const _6 = "._ca0qxy5q{padding-top:var(--ds-space-400,2pc)}";
const _5 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _4 = "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}";
const _3 = "._2rko12x7{border-radius:var(--ds-space-075,6px)}";
const _2 = "._1yt4pxbi{padding:var(--ds-space-200,1pc)}";
const _ = "._19itpp12{border:var(--_18x9sjc)}";
const siteSelectorSelectContainer = null;
const pricingContainer = null;
const singleSiteContainer = null;
const textStyles = null;
const renderAppInstalledError = (appName, baseSiteUrl, appKey) => /*#__PURE__*/_jsx(SiteSelectorError.AppAlreadyInstalled, {
  appName: appName,
  siteBaseUrl: baseSiteUrl,
  appKey: appKey
});
const renderCompatibleProductsAndPricing = (mpacBaseUrl, appDetails, hostStatus, isFreeApp, selectedSiteAndProduct, installedAppDetailsResult) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(SiteCompatibleProducts, {
    selectedSiteCloudId: selectedSiteAndProduct.site.cloudId,
    appCompatibleProduct: selectedSiteAndProduct.product,
    mpacBaseUrl: mpacBaseUrl,
    showStripe: true
  }), hostStatus.hostStatusLoading && /*#__PURE__*/_jsx(Stripe, {
    height: "6.875rem",
    marginTop: "var(--ds-space-075, 6px)"
  }), hostStatus.hostStatusError && /*#__PURE__*/_jsx(BodyNormal, {
    children: "Unknown Price"
  }), hostStatus.hostStatusResult && /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_19itpp12 _1yt4pxbi _2rko12x7 _19pkxy5q _otyrxy5q"]),
      style: {
        "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
      },
      children: isFreeApp ? /*#__PURE__*/_jsx(BodyNormal, {
        children: "Free"
      }) : /*#__PURE__*/_jsx(PaidAppPricing, {
        appDetails: appDetails,
        hostStatus: hostStatus.hostStatusResult,
        installedAppDetailsResult: installedAppDetailsResult
      })
    })]
  })]
});
const renderAvailableSites = (onSiteChange, availableSitesResult, firstCompatibleProduct, isSingleSiteAndProduct) => {
  if (isSingleSiteAndProduct) {
    const singleSite = availableSitesResult[0];
    const singleProduct = singleSite.products[0];
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_6, _7, _8]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_ca0qxy5q _n3td1ejb _vwz4viql"]),
        children: [/*#__PURE__*/_jsx(BodySmall, {
          children: "Site selected:"
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_9]
          }), /*#__PURE__*/_jsx(BodySmall, {
            className: ax(["_k48pni7l"]),
            children: formatLabel({
              site: singleSite,
              product: singleProduct,
              existsMoreThanOneProductForSite: false
            })
          })]
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsx(SiteSelectorSelectSection, {
    availableSites: availableSitesResult,
    firstAppCompatibility: firstCompatibleProduct,
    onSelectedSiteChange: onSiteChange
  });
};
export const SiteSelectorSelect = _ref => {
  let {
    appDetails,
    isFreeApp,
    firstCompatibleProduct,
    canUserInstallApp,
    selectedSiteAndProduct,
    mpacBaseUrl,
    onSiteChange,
    isAppInstalled,
    installedAppDetailsResult,
    availableSitesPromise,
    appInstallPermissionPromise,
    hostStatusPromise
  } = _ref;
  const [isSingleSiteAndProduct, setIsSingleSiteAndProduct] = useState(false);
  const {
    availableSitesResult,
    availableSitesPending,
    availableSitesError
  } = availableSitesPromise;
  const {
    appInstallPermissionResult,
    appInstallPermissionPending
  } = appInstallPermissionPromise;
  useEffect(() => {
    if (!selectedSiteAndProduct && availableSitesResult && availableSitesResult.length === 1 && availableSitesResult[0].products.length === 1) {
      const singleSite = availableSitesResult[0];
      const singleProduct = singleSite.products[0];
      onSiteChange({
        site: singleSite,
        product: singleProduct
      });
      setIsSingleSiteAndProduct(true);
    }
  }, [availableSitesResult, onSiteChange, selectedSiteAndProduct]);
  const handleOnSiteSelected = () => {
    if (!selectedSiteAndProduct) {
      return null;
    }
    if (isAppInstalled) {
      return renderAppInstalledError(appDetails.appName, selectedSiteAndProduct.site.url, appDetails.appKey);
    }
    if (appInstallPermissionPending) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Stripe, {
          width: "20rem",
          height: "0.875rem",
          marginTop: "var(--ds-space-075, 6px)"
        }), /*#__PURE__*/_jsx(Stripe, {
          height: "3.875rem",
          marginTop: "var(--ds-space-075, 6px)"
        })]
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [canUserInstallApp && renderCompatibleProductsAndPricing(mpacBaseUrl, appDetails, hostStatusPromise, isFreeApp, selectedSiteAndProduct, installedAppDetailsResult), appInstallPermissionResult && /*#__PURE__*/_jsx(SiteSelectorPermissionErrorSection, {
        isFreeApp: isFreeApp,
        installPermission: appInstallPermissionResult
      })]
    });
  };
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _11]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_1yt41ejb _10m4kb7n _1vdkkb7n _1wzn1wug _1yagcwrd _1mbp1wug"]),
      style: {
        "--_1ocxs6l": ix("var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-1000, 80px)"))
      },
      children: [/*#__PURE__*/_jsxs(H4, {
        children: ["Select a site to ", isFreeApp ? 'install your app' : 'start free trial']
      }), availableSitesError && /*#__PURE__*/_jsx(SiteSelectorError.Unknown, {}), availableSitesPending && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Stripe, {
          width: "10rem",
          height: "0.875rem",
          marginTop: "var(--ds-space-075, 6px)"
        }), /*#__PURE__*/_jsx(Stripe, {
          height: "2.875rem",
          marginTop: "var(--ds-space-075, 6px)"
        })]
      }), availableSitesResult && renderAvailableSites(onSiteChange, availableSitesResult, firstCompatibleProduct, isSingleSiteAndProduct), handleOnSiteSelected()]
    })]
  });
};